import useRoomConfig from "@pages/new-product/hooks/useRoomConfig";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Col, Row } from "react-bootstrap";
import Select from "@components/forms/Select";
import Choice from "@components/Choice";
import { addRoom } from "@services/redux/slices/hotelSlice";
import Input from "@components/forms/Input";
import { DatePicker } from "rsuite";
import { useModal } from "@components/ModalContext";
import { apiSend } from "@services/axios";

const Roomadd = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { closeModal } = useModal();

  const { roomTypes, roomOptions, mealTypes, bedTypes, loading, error } =
    useRoomConfig();

  // Local state for the new room
  const [roomData, setRoomData] = useState({
    room_type_id: null,
    room_option_id: null,
    bed_type_id: null,
    number_of_beds: 1,
    is_extra_beds_available: false,
    is_baby_beds_available: false,
    is_smoking_allowed: false,
    is_wheelchair_accessible: false,
    number_of_living_areas: 1,
    number_of_rooms: 1,
    total_rooms_of_this_type: 0,
    min_adults: 1,
    max_adults: 1,
    min_children: 0,
    max_children: 0,
    real_number_pax: 1,
    pricing: {
      start_date: "",
      end_date: "",
      price: "",
      mealId: null,
    }
  });

  // Handler for updating room data
  const handleChange = (field, value) => {
    setRoomData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Handler for nested pricing changes
  const handlePricingChange = (subField, value) => {
    setRoomData(prev => ({
      ...prev,
      pricing: {
        ...prev.pricing,
        [subField]: value
      }
    }));
  };



  // Handler for date changes
  // const handleStartDate = (val) => {
  //   if (val && val instanceof Date && !isNaN(val)) {
  //     handlePricingChange("start_date", val.toISOString().split("T")[0]);
  //   } else {
  //     handlePricingChange("start_date", "");
  //   }
  // };


  // const handleEndDate = (val) => {
  //   if (val && val instanceof Date && !isNaN(val)) {
  //     handlePricingChange("end_date", val.toISOString().split("T")[0]);
  //   } else {
  //     handlePricingChange("end_date", "");
  //   }
  // };
const formatDateLocal = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const handleStartDate = (val) => {
  if (!(val instanceof Date) || isNaN(val)) {
    handlePricingChange("start_date", "");
    handlePricingChange("end_date", "");
    return;
  }

  const start = formatDateLocal(val);
  handlePricingChange("start_date", start);

  // If end date is now invalid, clear it
  if (roomData.pricing.end_date && roomData.pricing.end_date <= start) {
    handlePricingChange("end_date", "");
  }
};

const handleEndDate = (val) => {
  if (!(val instanceof Date) || isNaN(val)) {
    handlePricingChange("end_date", "");
    return;
  }

  const end = formatDateLocal(val);

  if (!roomData.pricing.start_date) return;

  if (end > roomData.pricing.start_date) {
    handlePricingChange("end_date", end);
  }
};


  // Save the room
  const handleSave = async () => {
    // Validate required fields
    if (!roomData.room_type_id) {
      alert(t("please_select_room_type"));
      return;
    }

    if (!roomData.pricing.mealId) {
      alert(t("please_select_meal_type"));
      return;
    }

    // Dispatch to add room to Redux
    dispatch(addRoom(roomData));

    const payload = roomData;
    console.log("payload", payload)
    try {
      const res = await apiSend(
        `/product/hotel/${id}/new/rooms`,
        "post",
        { rooms: [payload] }
      );
      console.log("Room data", roomData);
      console.log("Room saved ✅", res.data);
    } catch (e) {
      console.error("Save room failed ❌", e);
    }


    // Close modal
    closeModal();
  };

  // Filter out empty options
  const filteredRoomTypes = roomTypes?.filter(item => item.title !== "") || [];
  const filteredRoomOptions = roomOptions?.filter(item => item.title !== "") || [];
  const filteredMealTypes = mealTypes?.filter(item => item.title !== "") || [];
  const filteredBedTypes = bedTypes?.filter(item => item.title !== "") || [];

  // Static options
  const roomsLength = Array.from({ length: 50 }, (_, index) => ({
    title: `${index + 1}`,
    value: index + 1,
  }));

  const bedCountOptions = Array.from({ length: 10 }, (_, i) => ({
    title: (i + 1).toString(),
    value: i + 1,
  }));

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
        <div className="loader" />
      </div>
    );
  }

  return (
    <div className="room-section p-4 bg-light z-2" >
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="text-dark">
          {t("new_room")}
        </h5>
      </div>

      {/* Room Information Section */}
      <div className="my-4">
        <span className="text-blue fs-5 d-flex align-items-center">
          {t("room_information")}
        </span>
        <p className="fs-6 mt-1 fw-light">{t("room_information_text")}</p>

        <Row className="align-items-center">
          <Col lg="6" className="my-3">
            <span className="text-dark fs-6">{t("room_type_q")}</span>
            <div className="mt-2">
              <Select
                data={filteredRoomTypes}
                value={roomData.room_type_id}
                handleChange={(e) => {
                  handleChange("room_type_id", Number(e.target.value));
                }}
              />
            </div>
          </Col>

          <Col lg="6" className="my-3">
            <span className="text-dark fs-6">{t("which_category_q")}</span>
            <div className="mt-2">
              <Select
                data={filteredRoomOptions}
                value={roomData.room_option_id}
                handleChange={(e) => {
                  handleChange("room_option_id", Number(e.target.value));
                }}
              />
            </div>
          </Col>
        </Row>

        {/* Living areas and rooms per type */}
        <Row className="align-items-center">
          <Col lg="6" className="my-3">
            <span className="text-dark fs-6">{t("spaces_length_q")}</span>
            <div className="mt-2">
              <Select
                data={roomsLength}
                value={roomData.number_of_living_areas}
                handleChange={(e) => {
                  handleChange("number_of_living_areas", parseInt(e.target.value));
                }}
              />
            </div>
          </Col>

          <Col lg="6" className="my-3">
            <span className="text-dark fs-6">{t("rooms_length_q")}</span>
            <div className="mt-2">
              <Select
                data={roomsLength}
                value={roomData.number_of_rooms}
                handleChange={(e) => {
                  handleChange("number_of_rooms", parseInt(e.target.value));
                }}
              />
            </div>
          </Col>
        </Row>

        {/* Smoking + Wheelchair options */}
        <Choice
          text={t("smoking_allowed_q")}
          selectedChoice={roomData.is_smoking_allowed ? "yes" : "no"}
          onChange={(value) =>
            handleChange("is_smoking_allowed", value === "yes")
          }
        />

        <Choice
          text={t("wheelchair_accessible_q")}
          selectedChoice={roomData.is_wheelchair_accessible ? "yes" : "no"}
          onChange={(value) =>
            handleChange("is_wheelchair_accessible", value === "yes")
          }
        />

        {/* Number of rooms of this type */}
        <Row className="align-items-center">
          <Col lg="6" className="my-3">
            <span className="fs-6 text-dark">{t("type_rooms_length_q")}</span>
          </Col>
          <Col lg="6" className="my-3">
            <Input
              type="number"
              placeholder={t("rooms")}
              value={roomData.total_rooms_of_this_type}
              onChange={(e) =>
                handleChange("total_rooms_of_this_type", Number(e.target.value))
              }
            />
          </Col>
        </Row>
      </div>

      <hr className="border-secondary my-4" />

      {/* Beds and Occupancy Section */}
      <div className="my-4">
        <span className="text-blue fs-5 d-flex align-items-center">
          {t("beds_and_occupancy")}
        </span>
        <p className="fs-6 fw-light my-1">{t("beds_and_occupancy_text")}</p>

        <div className="fs-6">
          {/* Bed Type + Count */}
          <Row className="align-items-center my-3">
            <Col sm="8" xl="4" className="my-2">
              <Select
                label={t("bed_type")}
                data={filteredBedTypes?.map((b) => ({ title: b.name, value: b.id })) || []}
                value={roomData.bed_type_id || ""}
                handleChange={(e) => {
                  handleChange("bed_type_id", Number(e.target.value));
                }}
              />
            </Col>

            <Col sm="4" xl="2" className="my-2">
              <Select
                label={t("number_of_beds")}
                data={bedCountOptions}
                value={roomData.number_of_beds || 1}
                handleChange={(e) => {
                  handleChange("number_of_beds", parseInt(e.target.value));
                }}
              />
            </Col>
          </Row>

          {/* Optional Extras */}
          <Choice
            text={t("add_babies_beds")}
            selectedChoice={roomData.is_baby_beds_available ? "yes" : "no"}
            onChange={(value) =>
              handleChange("is_baby_beds_available", value === "yes")
            }
          />

          <Choice
            text={t("add_extra_beds")}
            selectedChoice={roomData.is_extra_beds_available ? "yes" : "no"}
            onChange={(value) =>
              handleChange("is_extra_beds_available", value === "yes")
            }
          />
        </div>
      </div>

      <hr className="border-secondary my-4" />

      {/* Base Rate Section */}
      <div className="my-4">
        <span className="text-blue fs-5 d-flex align-items-center">
          {t("base_rate")}
        </span>
        <p className="fs-6 fw-light my-1">{t("base_rate_text")}</p>

        <div className="fs-6">
          {/* Occupancy Settings */}
          <h5 className="text-dark mt-3">{t("occupancy_settings")}</h5>
          <p className="text-muted mb-3">{t("occupancy_settings_caption")}</p>

          <Row className="my-3 fs-6 gy-3">
            {/* Adults */}
            <Col xs="12" md="6">
              <div className="fs-6 fw-medium mb-2 text-dark">{t("adults")}</div>
              <Row>
                <Col xs="6" className="mb-2">
                  <label className="d-block mb-1 small text-muted">
                    {t("min")}
                  </label>
                  <Input
                    type="number"
                    min={1}
                    placeholder={t("min")}
                    value={roomData.min_adults}
                    onChange={(e) =>
                      handleChange("min_adults", parseInt(e.target.value) || 1)
                    }
                  />
                </Col>
                <Col xs="6" className="mb-2">
                  <label className="d-block mb-1 small text-muted">
                    {t("max")}
                  </label>
                  <Input
                    type="number"
                    min={1}
                    placeholder={t("max")}
                    value={roomData.max_adults}
                    onChange={(e) =>
                      handleChange("max_adults", parseInt(e.target.value) || 2)
                    }
                  />
                </Col>
              </Row>
            </Col>

            {/* Children */}
            <Col xs="12" md="6">
              <div className="fs-6 fw-medium mb-2 text-dark">{t("children")}</div>
              <Row>
                <Col xs="6" className="mb-2">
                  <label className="d-block mb-1 small text-muted">
                    {t("min")}
                  </label>
                  <Input
                    type="number"
                    min={0}
                    placeholder={t("min")}
                    value={roomData.min_children}
                    onChange={(e) =>
                      handleChange("min_children", parseInt(e.target.value) || 0)
                    }
                  />
                </Col>
                <Col xs="6" className="mb-2">
                  <label className="d-block mb-1 small text-muted">
                    {t("max")}
                  </label>
                  <Input
                    type="number"
                    min={0}
                    placeholder={t("max")}
                    value={roomData.max_children}
                    onChange={(e) =>
                      handleChange("max_children", parseInt(e.target.value) || 2)
                    }
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          {/* Real Pax */}
          <h5 className="text-dark mt-4">{t("real_number_pax_title")}</h5>
          <p className="text-muted mb-3">{t("real_number_pax_caption")}</p>

          <Choice
            text={t("real_number_pax_q")}
            selectedChoice={roomData.real_number_pax === 1 ? "yes" : "no"}
            onChange={(value) =>
              handleChange("real_number_pax", value === "yes" ? 1 : 0)
            }
          />

          {/* Pricing Section */}
          <h5 className="text-dark mt-4">{t("pricing_section")}</h5>
          <p className="text-muted mb-3">{t("pricing_section_caption")}</p>

          <Row className="align-items-center my-3  pb-7 fs-6">
            {/* Start Date */}
            <Col xs="12" md="6" lg="3" className="my-2 z-3">
              <span className="text-dark d-block mb-1 ">{t("start_date")}</span>

              <DatePicker
                className="border w-100"
                oneTap
                placeholder={t("start_day")}
                value={roomData.pricing.start_date ? new Date(roomData.pricing.start_date) : null}
                onChange={handleStartDate}
              />
            </Col>

            {/* End Date */}
            <Col xs="12" md="6" lg="3" className="my-2">
              <span className="text-dark d-block mb-1">{t("end_date")}</span>
              <DatePicker
                className="border w-100"
                oneTap
                placeholder={t("end_date_placeholder")}
                value={roomData.pricing.end_date ? new Date(roomData.pricing.end_date) : null}
                onChange={handleEndDate}
                disabledDate={(date) => {
                  if (!roomData.pricing.start_date) return false;
                  return date <= new Date(roomData.pricing.start_date);
                }}
              />
            </Col>

            {/* Meal Type */}
            <Col md="6" lg="3" className="my-2">
              <Select
                data={filteredMealTypes}
                value={roomData.pricing.mealId || ""}
                handleChange={(e) => {
                  handlePricingChange("mealId", e.target.value);
                }}
              />
            </Col>

            {/* Price */}
            <Col md="6" lg="3" className="my-2">
              <Input
                type="number"
                placeholder={t("price_placeholder")}
                value={roomData.pricing.price}
                onChange={(e) =>
                  handlePricingChange("price", Number(e.target.value) || 200)
                }
              />
            </Col>
          </Row>
        </div>
      </div>

      {/* Save/Cancel Buttons */}
      <div className="d-flex justify-content-end gap-3 mt-5 pt-4 border-top"  >
        <button
          type="button"
          className="btn btn-outline-secondary px-4"
          onClick={closeModal}
        >
          {t("cancel")}
        </button>
        <button
          type="button"
          className="btn btn-primary px-4"
          onClick={handleSave}
        >
          {t("save_room")}
        </button>
      </div>
    </div>
  );
};

export default Roomadd;